import {Component, OnInit, TemplateRef} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {IAfterGuiAttachedParams, ICellRendererParams} from 'ag-grid-community';
import {faInfoCircle} from '@fortawesome/free-solid-svg-icons';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';

@Component({
  selector: 'lib-info-cell',
  templateUrl: './info-cell.component.html',
  styleUrls: ['./info-cell.component.css']
})
export class InfoCellComponent implements ICellRendererAngularComp, OnInit {
   modalRef: BsModalRef;
   faInfoCircle = faInfoCircle;
   public params;
   public highlight: boolean = false;

  constructor(private modalService: BsModalService) { }

  ngOnInit(): void {
    this.checkValues(this.params.data.hinweisEmpfaenger);
    this.checkValues(this.params.data.hinweisOperativ);
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  displayInfos(template: TemplateRef<any>): void {
    const config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: true,
    };
    this.modalRef = this.modalService.show(template, config);
  }

  checkValues(values: any) {
    if(values === null) {
      return 'Keine Hinweise vorhanden!';
    }else {
      this.highlight = true;
      return values;
    }
  }

  showEmpfaengerName(param: any) {
    const name1 = param.data.empfaengerName1 !== null ? param.data.empfaengerName1 : '';
    const name2 = param.data.empfaengerName2 !== null ? param.data.empfaengerName2 : '';
    const name3 = param.data.empfaengerName3 !== null ? param.data.empfaengerName3 : '';
    return name1 + ' ' + name2 + ' ' + name3;
  }
}
